import React from 'react';

const ConfirmationDialog = ({ show, onCancel, onConfirm, title, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: 'var(--modal-background, #fff)',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 8px 32px var(--modal-shadow, rgba(0, 0, 0, 0.2))',
          position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: '0 0 16px 0', color: 'var(--text-color, #212529)', fontSize: '1.25rem', fontWeight: '600' }}>
          {title}
        </h3>
        <p style={{ margin: '0 0 24px 0', color: 'var(--text-color, #212529)', fontSize: '1rem', lineHeight: '1.5' }}>
          {children}
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button onClick={onCancel} className="themed-button" style={{ background: 'transparent', color: 'inherit', border: '1px solid var(--border-color)' }}>
            Cancel
          </button>
          <button onClick={onConfirm} className="themed-button">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
